import Network from "./network";
import * as util from "./util";
import NeatParameters from "./parameters";

class Specie {
  private representative: Network;
  private organisms: Network[];

  constructor(network: Network) {
    this.representative = network;
    this.organisms = [network];
  }

  private isCloseEnough(network: Network, params: NeatParameters): boolean {
    const metric = this.representative.compatibilityMetric(network, params);
    return metric <= params.speciation.compatibilityThreshold;
  }

  tryAdding(network: Network, params: NeatParameters): boolean {
    if (this.isCloseEnough(network, params)) {
      this.organisms.push(network);
      return true;
    }

    return false;
  }

  killWorst(survivalRate: number): void {
    const survived = this.organisms.length * survivalRate;
    this.organisms.splice(Math.max(1, survived));
  }

  getElites(eliteNum: number): Network[] {
    const elites = [];
    for (let i = 0; i < Math.min(eliteNum, this.organisms.length); i++) {
      elites.push(this.organisms[i]);
    }

    return elites;
  }

  getFitnessSum(): number {
    let sum = 0;
    for (const organism of this.organisms) {
      sum += organism.getFitness() / this.organisms.length;
    }

    return sum;
  }

  mate(): Network {
    const a = util.randomChoice(this.organisms);
    const b = util.randomChoice(this.organisms);

    return a.crossover(b);
  }
}

export default Specie;
